import React from "react";
import DynamicHtml from "@common/DynamicHtml";
import { HtmlContentLoader } from "@shared";
import { CONSTANT } from "../../constant";

const PostSearchSection = ({ 
  showPostSearch,
  showNoResults,
  safeChannelName,
  cardResultName,
  resultName,
  hierarchyShortName,
  geoLocationValue,
  coverageCardHtml,
  channel,
  matchesMobileWidth,
  coverageHtmlMobileUrl,
  coverageHtmlDesktopUrl,
  onAnchorClick
}) => {
  if (!showPostSearch && !showNoResults) return null;
  
  if (showNoResults) {
    return (
      <div className={`norstella-pf-row norstella-pf-row-post norstella-pf-${safeChannelName}-row-post`}>
            <div className={`norstella-pf-no-results-message norstella-pf-${safeChannelName}-no-results-message`}>
              {CONSTANT.NO_RESULTS_FOUND}
            </div>  
      </div>
    );
  }

  return (
    <div className={`norstella-pf-row norstella-pf-row-post norstella-pf-${safeChannelName}-row-post`}>
      <div className={`norstella-pf-post-search-content norstella-pf-${safeChannelName}-post-search-content`}>
        {cardResultName && (
          <div className={`norstella-pf-cardResultName-section norstella-pf-${safeChannelName}-cardResultName-section`}>
            <DynamicHtml 
              input={cardResultName} 
              className={`norstella-pf-cardResultName norstella-pf-${safeChannelName}-cardResultName`} 
              part="cfCardResultName" 
              resultname={resultName}
              hierarchyShortName={hierarchyShortName}
              stateName={geoLocationValue.state}
              zipCode={geoLocationValue.zipCode}
            />
          </div>
        )}
        {coverageCardHtml && (
          <div className={`norstella-pf-coverageCardHtml-section norstella-pf-${safeChannelName}-coverageCardHtml-section`}>
            <DynamicHtml 
              input={coverageCardHtml} 
              className={`norstella-pf-coverageCardHtml norstella-pf-${safeChannelName}-coverageCardHtml`} 
              part="cfCoverageCardHtml" 
              resultname={resultName}
              hierarchyShortName={hierarchyShortName}
              channelName={channel.channelName}
              stateName={geoLocationValue.state}
              zipCode={geoLocationValue.zipCode}
            />
          </div>
        )}
        {!coverageCardHtml && (<div className={`norstella-pf-no-plan-details norstella-pf-${safeChannelName}-no-plan-details`}>
            {CONSTANT.NO_PLAN_DETAILS}
          </div>)}
        <div className={`norstella-pf-externalCoverageCardHtml-section norstella-pf-${safeChannelName}-externalCoverageCardHtml-section`}>
          <HtmlContentLoader url={matchesMobileWidth ? coverageHtmlMobileUrl : coverageHtmlDesktopUrl} onAnchorClick={onAnchorClick} />
        </div>
      </div>
    </div>
  );
};

export default PostSearchSection;
